import React from "react";
import Select from "react-select";

const UserSelection = ({
  onChange,
  options,
  error,
  selectedUsers,
  padding = 4,
  disable = false,
}) => {
  const handleChange = (selectedOptions) => {
    onChange(selectedOptions);
  };

  return (
    <div className="w-full sm:pl-1">
      <Select
        options={options}
        isMulti
        isDisabled={disable}
        value={selectedUsers}
        onChange={handleChange}
        className="react-select-container"
        classNamePrefix="react-select"
        noOptionsMessage={() => "Không có lựa chọn"}
        placeholder="Chọn người dùng"
        styles={{
          control: (base) => ({
            ...base,
            borderRadius: "8px",
            padding: `${padding}px`,
            borderColor: error ? "rgb(240 128 128)" : "rgb(209 213 219)",
            boxShadow: "none",
            "&:hover": {
              borderColor: "rgb(209 213 219)",
            },
          }),
        }}
      />
    </div>
  );
};

export default UserSelection;
